module.exports = __webpack_public_path__ + "static/media/planIncidentes.92fffe47.png";